var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.257,
    height: 33.226,
    viewBox: "0 0 33.257 33.226",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "edit_FILL0_wght300_GRAD0_opsz24_1_",
    "data-name": "edit_FILL0_wght300_GRAD0_opsz24 (1)",
    d: "M149.1-787.023h2.426l18.17-18.169-2.426-2.426-18.17,18.17Zm26.89-20.3-6.622-6.562,2.558-2.558a2.861,2.861,0,0,1,2.1-.864,2.861,2.861,0,0,1,2.1.864l2.389,2.389a2.936,2.936,0,0,1,.894,2.072,2.723,2.723,0,0,1-.834,2.072Zm-2.128,2.158-21.083,21.083h-6.622V-790.7l21.083-21.083Zm-5.388-1.253-1.2-1.2,2.426,2.426Z",
    transform: "translate(-146.156 817.305)",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconWhite);
export default __webpack_public_path__ + "static/media/edit-icon-white.080fb5005e03e7500d02ebc1a0525a95.svg";
export { ForwardRef as ReactComponent };